import { useEffect, useState } from 'react';
import CurrentLocation from '../current-location/current-location';
import LocationDropdown from '../location-dropdown/location-dropdown';

const RedirectNotificationBar = (props) => {
	const {
		type,
		site_url,
		current_country_code,
		current_language,
		current_flag_URL,
		redirect_message,
		locations,
	} = props;
	const [visible, setVisible] = useState(true);
	const [isLocationsOpen, setIsLocationsOpen] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setVisible(false);
		}, 21000);

		return () => clearTimeout(timer);
	}, []);

	const handleClick = () => {
		setVisible(false);
	};

	const toggleLocationsClass = () => {
		setIsLocationsOpen((prevState) => !prevState);
	};

	const classNames = `notification-bar notification-bar--${type}`;

	return (
		<>
			{visible && (
				<div className={classNames}>
					<div className="notification-bar__inner">
						<p className="notification-bar__text">
							{redirect_message}
						</p>
						{type === 'redirect' && (
							<div className="notification-bar__grid">
								<div className="notification-bar__suggested">
									<button
										onClick={toggleLocationsClass}
										className={`locations${
											isLocationsOpen
												? ' locations--open'
												: ''
										}`}
									>
										<CurrentLocation
											country_code={current_country_code}
											language={current_language}
											flag_URL={current_flag_URL}
										></CurrentLocation>
										<LocationDropdown
											locations={locations}
										></LocationDropdown>
									</button>
								</div>
								<a
									alt="redirect"
									href={site_url}
									className="notification-bar__btn btn"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M20 6 9 17l-5-5" />
									</svg>
									Redirect me!
								</a>
								<button
									className="notification-bar__close"
									onClick={() => handleClick()}
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M18 6 6 18" />
										<path d="m6 6 12 12" />
									</svg>
								</button>
							</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default RedirectNotificationBar;
